import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Subject, mergeMap, Subscription } from 'rxjs';
import { LoggerService } from '@lib.core/logger/logger.service';
import { ContextStore } from '@lib.resources/context/context-store.service';

@Injectable({
  providedIn: 'root'
})
export class LangQParamInteractor {
  private readonly contextNameId = 'application';
  private readonly langParam = 'lang';
  private readonly defaultLang = 'en';
  private readonly subscriptions: Subscription[] = [];
  private logger: LoggerService;
  private readonly qParamReaderTrigger$$ = new Subject<void>();
  private readonly qParamReaderTrigger$ = this.qParamReaderTrigger$$.asObservable();

  constructor(
    private activatedRoute: ActivatedRoute,
    private contextService: ContextStore,
  ) {
    this.logger = LoggerService.getLoggerService();
    this.subscribeToQParamReader();
  }

  readLangFromQParam() {
    this.qParamReaderTrigger$$.next();
  }

  destroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private subscribeToQParamReader() {
    this.subscriptions.push(
      this.qParamReaderTrigger$.pipe(
        mergeMap(() => this.activatedRoute.queryParams),
        map(qp => qp[this.langParam] ?? this.defaultLang)
      )
      .subscribe({
        next:  (lang: string) => {
          this.contextService.updateContextLang(this.contextNameId, lang);
        },
        error: (error) => this.logger.error(error),
      })
    );
  }
}
